export default __webpack_public_path__ + "stamp.asset.ddce34bea21f1aa2f937232958d9e80e.svg";